import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {FormBuilder} from '@angular/forms';
import {QUICK_FILTER_LIST, QuickFilterCategory} from '../../../model/filter';
import {GeospatialFilterStore} from '../../../api/geospatial-filter.store';
import {FilterAccordion} from '@theme/components/layout/control-panel/filter-accordion';

@Injectable()
export class FilterControlsStore extends FilterAccordion {
    // Control panel > Filter > quick filters; map control > quick filters
    private quickFilters: BehaviorSubject<QuickFilterCategory[]> = new BehaviorSubject<QuickFilterCategory[]>(
        QUICK_FILTER_LIST,
    );
    readonly quickFilters$: Observable<QuickFilterCategory[]> = this.quickFilters.asObservable();

    constructor(fb: FormBuilder, private geospatialFilterStore: GeospatialFilterStore) {
        super(fb);
    }
}
